import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5fabdf36"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "post" }
const _hoisted_2 = { class: "postCart" }
const _hoisted_3 = { class: "action" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "action" }
const _hoisted_9 = {
  key: 0,
  class: "action"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = { key: 1 }

import { computed, ref, watchEffect } from "vue";
import message from "@arco-design/web-vue/es/message";
import router from "@/router";
import {
  deletePostUsingPost,
  getPostVoByIdUsingGet,
} from "@/api/postController";
import dayjs from "dayjs";
import { useLoginUserStore } from "@/store/userStore";
import CommentCart from "@/components/list/CommentCart.vue";
import {
  doPostFavourUsingPost,
  doPostThumbUsingPost,
} from "@/request/api/postController";
import UserSider from "@/components/sider/UserSider.vue";
import MdViewer from "@/components/md/MdViewer.vue";
import ShareTrigger from "@/components/trigger/ShareTrigger.vue";

interface Props {
  id: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PostDetailPage',
  props: {
    id: { default: () => {
    return 0;
  } }
  },
  setup(__props: any) {

const props = __props;

const data = ref<API.PostVO>({});
const loginUser = useLoginUserStore().loginUser;
const isMy = computed(() => {
  return loginUser.id && loginUser.id === data.value.userId;
});
const loading = ref(false);

/**
 * 加载数据
 */
const loadData = async () => {
  loading.value = true;
  const response = await getPostVoByIdUsingGet({ id: props.id });
  if (response.data.code === 0 && response.data.data) {
    data.value = response.data.data;
  } else {
    message.error("加载数据失败，" + response.data.message);
  }
  loading.value = false;
};

/**
 * 点赞
 */
const onLikeChange = (item: any) => {
  if (item.isThumb == true) {
    item.thumbNum--;
  } else {
    item.thumbNum++;
  }
  item.isThumb = !item.isThumb;
  doPostThumbUsingPost({ bizId: item.id, bizType: "Post" });
};

/**
 * 收藏
 */
const onStarChange = (item: any) => {
  if (item.isFavour == true) {
    item.favourNum--;
  } else {
    item.favourNum++;
  }
  item.isFavour = !item.isFavour;
  doPostFavourUsingPost({ bizId: item.id, bizType: "Post" });
};

/**
 * 删除帖子
 */
const remove = async (id: number) => {
  const response = await deletePostUsingPost({ id: id });
  if (response.data.code === 0) {
    message.success("删除成功");
    router.push("/");
  } else {
    message.error("删除失败，" + response.data.message);
  }
};
/**
 * 编辑帖子
 */
const edit = async (id: number) => {
  router.push("/post/edit/" + id);
};
/**
 * 点击菜单项
 * @param id
 */
const onClickMenuItem = async (url: string) => {
  router.push(url);
};
/**
 * 监听 searchParams 变量，改变时触发数据的重新加载
 */
watchEffect(() => {
  loadData();
});

return (_ctx: any,_cache: any) => {
  const _component_icon_eye = _resolveComponent("icon-eye")!
  const _component_IconHeartFill = _resolveComponent("IconHeartFill")!
  const _component_IconHeart = _resolveComponent("IconHeart")!
  const _component_IconStarFill = _resolveComponent("IconStarFill")!
  const _component_IconStar = _resolveComponent("IconStar")!
  const _component_icon_edit = _resolveComponent("icon-edit")!
  const _component_icon_delete = _resolveComponent("icon-delete")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_image_preview_group = _resolveComponent("a-image-preview-group")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_list_item_meta = _resolveComponent("a-list-item-meta")!
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createBlock(_component_a_row, {
    class: "postDetail",
    justify: "center"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, { span: "16" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_a_spin, { loading: loading.value }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_list_item, {
                    class: "postItem",
                    "action-layout": "vertical"
                  }, {
                    actions: _withCtx(() => [
                      _createElementVNode("span", _hoisted_3, [
                        _createVNode(_component_icon_eye),
                        _createTextVNode(" " + _toDisplayString(data.value.viewNum), 1)
                      ]),
                      _createElementVNode("span", {
                        class: "action",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (onLikeChange(data.value)))
                      }, [
                        (data.value.isThumb)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                              _createVNode(_component_IconHeartFill, { style: { color: '#f53f3f' } })
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_5, [
                              _createVNode(_component_IconHeart)
                            ])),
                        _createTextVNode(" " + _toDisplayString(data.value.thumbNum), 1)
                      ]),
                      _createElementVNode("span", {
                        class: "action",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (onStarChange(data.value)))
                      }, [
                        (data.value.isFavour)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                              _createVNode(_component_IconStarFill, { style: {"color":"#fff35d"} })
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_7, [
                              _createVNode(_component_IconStar)
                            ])),
                        _createTextVNode(" " + _toDisplayString(data.value.favourNum), 1)
                      ]),
                      _createElementVNode("span", _hoisted_8, [
                        _createVNode(ShareTrigger)
                      ]),
                      _createVNode(_component_a_space, { size: "medium" }, {
                        default: _withCtx(() => [
                          (isMy.value)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: "action",
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (edit(data.value.id)))
                              }, [
                                _createVNode(_component_icon_edit)
                              ]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_a_popconfirm, {
                            content: "你确定要删除吗?",
                            onOk: _cache[3] || (_cache[3] = ($event: any) => (remove(data.value.id))),
                            position: "bottom"
                          }, {
                            default: _withCtx(() => [
                              (isMy.value)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                                    _createVNode(_component_icon_delete)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_list_item_meta, null, {
                        title: _withCtx(() => [
                          _createVNode(_component_a_space, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_avatar, {
                                "image-url": data.value.user?.userAvatar
                              }, null, 8, ["image-url"]),
                              _createElementVNode("div", null, [
                                _createVNode(_component_a_typography_text, { style: {"font-size":"16px","font-weight":"bold"} }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(data.value.user?.userName), 1)
                                  ]),
                                  _: 1
                                }),
                                _hoisted_10,
                                _createVNode(_component_a_typography_text, { style: {"color":"#9f9f9f"} }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(dayjs)(data.value.updateTime).format("YYYY-MM-DD HH:mm:ss")), 1)
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        description: _withCtx(() => [
                          _createElementVNode("div", {
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (onClickMenuItem(`/post/detail/${data.value.id}`)))
                          }, [
                            _withDirectives(_createElementVNode("div", null, [
                              _createVNode(_component_a_typography_text, { style: {"font-size":"20px","margin-left":"18px"} }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(data.value.title), 1)
                                ]),
                                _: 1
                              })
                            ], 512), [
                              [_vShow, data.value.title]
                            ]),
                            _createVNode(MdViewer, {
                              value: data.value.content
                            }, null, 8, ["value"])
                          ]),
                          (data.value.imgList?.length > 0)
                            ? (_openBlock(), _createBlock(_component_a_image_preview_group, { key: 0 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_space, {
                                    size: "large",
                                    style: {"margin":"10px 20px"}
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value.imgList, (item) => {
                                        return (_openBlock(), _createBlock(_component_a_image, {
                                          key: item,
                                          src: item,
                                          width: "200"
                                        }, null, 8, ["src"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _hoisted_11,
                          (data.value.imgList?.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                _createVNode(_component_a_space, { style: {"margin":"10px 20px"} }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value.tagList, (item) => {
                                      return (_openBlock(), _createBlock(_component_a_tag, { key: item }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item), 1)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    }), 128))
                                  ]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["loading"])
            ]),
            _createVNode(CommentCart, {
              class: "postComment",
              "biz-type": "Post",
              "biz-id": props.id
            }, null, 8, ["biz-id"])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_a_col, { span: "6" }, {
        default: _withCtx(() => [
          _createVNode(UserSider, { "biz-type": "post" })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})